var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStatePatternCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "320px",
    height: "231px",
    viewBox: "0 0 320 231",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "background image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 360,
    height: 271
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Job-overview_empty-state",
    transform: "translate(-401.000000, -120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-image",
    transform: "translate(361.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.000000, 40.000000)",
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.5,56 C343.948821,56 427,139.051179 427,241.5 C427,343.948821 343.948821,427 241.5,427 C139.051179,427 56,343.948821 56,241.5 C56,139.051179 139.051179,56 241.5,56 Z M241.5,84.3599464 C154.713945,84.3599464 84.3599464,154.713945 84.3599464,241.5 C84.3599464,328.286055 154.713945,398.640054 241.5,398.640054 C328.286055,398.640054 398.640054,328.286055 398.640054,241.5 C398.640054,154.713945 328.286055,84.3599464 241.5,84.3599464 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,110 C313.349302,110 372,168.650698 372,241 C372,313.349302 313.349302,372 241,372 C168.650698,372 110,313.349302 110,241 C110,168.650698 168.650698,110 241,110 Z M241,138.384694 C184.327131,138.384694 138.384694,184.327131 138.384694,241 C138.384694,297.672869 184.327131,343.615306 241,343.615306 C297.672869,343.615306 343.615306,297.672869 343.615306,241 C343.615306,184.327131 297.672869,138.384694 241,138.384694 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5,0 C373.324482,0 481,107.675518 481,240.5 C481,373.324482 373.324482,481 240.5,481 C107.675518,481 0,373.324482 0,240.5 C0,107.675518 107.675518,0 240.5,0 Z M240.5,28.4055118 C123.363449,28.4055118 28.4055118,123.363449 28.4055118,240.5 C28.4055118,357.636551 123.363449,452.594488 240.5,452.594488 C357.636551,452.594488 452.594488,357.636551 452.594488,240.5 C452.594488,123.363449 357.636551,28.4055118 240.5,28.4055118 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatePatternCircles);
export default __webpack_public_path__ + "static/media/empty-state-pattern-circles.b4729db9c6ed7509a51a62bc805dcd99.svg";
export { ForwardRef as ReactComponent };